import type { ReactElement } from 'react';
import type { FieldError } from 'react-hook-form';
import { BaseInput, type BaseInputProps } from './BaseInput';
import { InputFeedback } from './InputFeedback';

type InputControlProps = Omit<
  BaseInputProps,
  'className' | 'defaultValue' | 'error' | 'name'
> & {
  defaultPlaceholder: string;
  defaultValue?: string | null;
  error?: FieldError | false;
  errorId: string;
  errorMessage?: (error: FieldError) => string;
  handlers: Pick<BaseInputProps, 'onKeyDown' | 'onPaste'>;
  hideError?: boolean;
  inputClassName?: string;
  inputContainerClassName?: string;
  maxLength?: number;
  name: string;
};

export function InputControl({
  defaultPlaceholder,
  defaultValue,
  error,
  errorId,
  errorMessage,
  handlers,
  hideError,
  inputClassName,
  inputContainerClassName,
  maxLength,
  name,
  placeholder,
  ...inputProps
}: InputControlProps): ReactElement {
  return (
    <div className={inputContainerClassName}>
      <BaseInput
        {...inputProps}
        {...handlers}
        aria-describedby={error ? errorId : undefined}
        aria-errormessage={errorId}
        className={inputClassName}
        defaultValue={defaultValue ?? undefined}
        error={!!error}
        name={name}
        placeholder={placeholder || defaultPlaceholder}
      />
      <InputFeedback
        error={error}
        errorId={errorId}
        errorMessage={errorMessage}
        hideError={hideError}
        maxLength={maxLength}
        name={name}
      />
    </div>
  );
}
